import { render, staticRenderFns } from "./TechnicAccess.vue?vue&type=template&id=07481a74&scoped=true&"
import script from "./TechnicAccess.vue?vue&type=script&lang=js&"
export * from "./TechnicAccess.vue?vue&type=script&lang=js&"
import style0 from "./TechnicAccess.vue?vue&type=style&index=0&id=07481a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07481a74",
  null
  
)

export default component.exports